import { Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useInView } from "../../util/useInView";
import type { Product } from "./ProdutosContent";

const pad = (n: number) => String(n).padStart(2, "0");

// Um produto num painel (como os cases em detalhe): o que ele resolve à esquerda, pilares em 2x2 à direita e a
// frase-resumo no rodapé. Os blocos entram em cascata quando o painel aparece. band = fundo em faixa clara.
export default function ProductSection({ product, band }: { product: Product; band?: boolean }) {
  const { t } = useTranslation();
  const { id, Icon, name, accent, heading, points, pillars, tip } = product;
  const [ref, state] = useInView<HTMLElement>(0.15);

  return (
    <section
      className={`cz-prod-section${band ? " cz-prod-section--band" : ""}`}
      id={id}
      aria-labelledby={`${id}-title`}
    >
      <div className="cz-prod-section__inner">
        <article ref={ref} className={`cz-prod-panel${state}`}>
          <header className="cz-prod-panel__lead">
            <span className="cz-prod-panel__badge" aria-hidden="true">
              <Icon size={30} strokeWidth={1.6} />
            </span>
            <div className="cz-prod-panel__heading">
              <span className="cz-eyebrow">{t("produtos_page.labels.eyebrow")}</span>
              <h2 className="cz-prod-title" id={`${id}-title`}>
                {name} <span className="cz-prod-accent">{accent}</span>
              </h2>
            </div>
          </header>

          <div className="cz-prod-panel__body">
            <div className="cz-prod-panel__col">
              <p className="cz-prod-panel__quote" data-reveal style={{ "--i": 0 } as React.CSSProperties}>
                {heading}
              </p>
              <ol className="cz-prod-points">
                {points.map((point, i) => (
                  <li key={point} data-reveal style={{ "--i": 1 + i } as React.CSSProperties}>
                    <span className="cz-prod-num" aria-hidden="true">
                      {pad(i + 1)}
                    </span>
                    {point}
                  </li>
                ))}
              </ol>
            </div>

            <div className="cz-prod-panel__col">
              <span className="cz-prod-label">{t("produtos_page.labels.pillars")}</span>
              <ul className="cz-prod-tiles cz-prod-tiles--pillars">
                {pillars.map(({ Icon: PillarIcon, title }, i) => (
                  <li
                    key={title}
                    className="cz-prod-tile"
                    data-reveal
                    style={{ "--i": 1 + points.length + i } as React.CSSProperties}
                  >
                    <span className="cz-prod-tile__icon" aria-hidden="true">
                      <PillarIcon size={20} strokeWidth={1.8} />
                    </span>
                    <strong className="cz-prod-tile__title">{title}</strong>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <footer className="cz-prod-panel__foot">
            <p className="cz-prod-tip">
              <Lightbulb size={18} strokeWidth={1.8} aria-hidden="true" />
              <span>{tip}</span>
            </p>
          </footer>
        </article>
      </div>
    </section>
  );
}
